import {
  SEND_MY_CURRENT_LOCATION,
  SEND_MY_CURRENT_LOCATION_SUCCESS,
  SEND_MY_CURRENT_LOCATION_FAILURE,
} from "./actionType";

//Actions
export const sendMyCurrentLocation = (payload) => ({
  type: SEND_MY_CURRENT_LOCATION,
  payload,
});

export const sendMyCurrentLocationSuccess = (payload) => ({
  type: SEND_MY_CURRENT_LOCATION_SUCCESS,
  payload,
});

export const sendMyCurrentLocationFailure = (payload) => ({
  type: SEND_MY_CURRENT_LOCATION_FAILURE,
  payload,
});
